import script from "./UserSettingsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSettingsCard.vue?vue&type=script&setup=true&lang=js"

import "./UserSettingsCard.vue?vue&type=style&index=0&id=6e77677d&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e77677d"]])

export default __exports__